import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error h-full w-full" }

import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'error',
  setup(__props) {

const route = useRoute();
const { t } = useI18n();
const type = ref("DEFAULT");

onMounted(() => {
   if(route.query.error) {
    type.value = route.query.error as string;
   }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_unref(t)('error.' + type.value)), 1)
  ]))
}
}

})